import React, { useEffect, useState } from "react";
import ReactDOM from 'react-dom';

export const Portal: React.FC<any> = ({children, forcePortal}) => {
  const [shouldRenderPortal, setShouldRenderPortal] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setShouldRenderPortal(forcePortal || (window.innerWidth <= 700 || (window.innerWidth >= 770 && window.innerWidth <= 1180)));
    };

    handleResize();

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  
    const portalRoot = document.getElementById('portal-root');
    if (!portalRoot) return null

    return (
      <>
        { shouldRenderPortal ?
            ReactDOM.createPortal(
                <>
                    {children}
                </>,
                portalRoot
            )
            :
            <>
                {children}
            </>
        }
      </>
    )
}